import { useReportingTrial } from '@cast/shared-trial-ui';

import { TrialAboutToEndBanner } from './TrialAboutToEndBanner';
import { TrialChangedMindBanner } from './TrialChangedMindBanner';
import { TrialHasEndedBanner } from './TrialHasEndedBanner';
import { TrialJustStartedBanner } from './TrialJustStartedBanner';
import { TrialViewerBanner } from './TrialViewerBanner';

type Props = {
  aboutToEndBanner?: boolean;
  hasEndedBanner?: boolean;
  justStartedBanner?: boolean;
  viewerBanner?: boolean;
  changedMindBanner?: boolean;
};

export const TrialBannerManager = ({
  aboutToEndBanner = false,
  hasEndedBanner = false,
  justStartedBanner = false,
  viewerBanner = false,
  changedMindBanner = false,
}: Props) => {
  const { isEligible: isReportingEligible } = useReportingTrial();

  // Reporting monetization owns trial UX for eligible orgs — never PLG banners.
  if (isReportingEligible) {
    return null;
  }

  return (
    <>
      {aboutToEndBanner && <TrialAboutToEndBanner />}
      {hasEndedBanner && <TrialHasEndedBanner />}
      {justStartedBanner && <TrialJustStartedBanner />}
      {viewerBanner && <TrialViewerBanner />}
      {changedMindBanner && <TrialChangedMindBanner />}
    </>
  );
};
